
import { computed, ref } from 'vue'
import { postSendCmd } from '@/api/device-cmd'
import { DeviceCmd, DeviceCmdItemAction } from '@/types/device-cmd'

export function useDockControl () {
  // const dockControlPanelVisible = ref(false)

  // 远程调试开关
  async function dockDebugOnOff (sn: string, on: boolean) {
    const result = await sendDockControlCmd({
      sn: sn,
      cmd: on ? DeviceCmd.DebugModeOpen : DeviceCmd.DebugModeClose
    }, false)
    return result
  }

  // 发送指令
  async function sendDockControlCmd (params: {
    sn: string,
    cmd: DeviceCmd
    action?: DeviceCmdItemAction
  }, tip = true) {
    try {
      let body = {} as any
      console.log(params)
      body = {
        action: params.action,
        sn: params.sn,
        serviceIdentifier: params.cmd
      }
      const result = await postSendCmd(body)
      ElMessage.success('指令发送成功')
      return true
    } catch (e) {
      // tip && message.error('指令发送失败')
      return false
    }
  }

  // 控制面板关闭
  async function onCloseControlPanel (sn: string, status: boolean) {
    if (status) {
      await dockDebugOnOff(sn, false)
    }
  }

  return {
    // dockControlPanelVisible,
    sendDockControlCmd,
    dockDebugOnOff,
    onCloseControlPanel,
  }
}
